import { TowerService } from "../../api/service/tower.service";
import { Router } from "@angular/router";
var QueuesComponent = /** @class */ (function () {
    function QueuesComponent(router, towerService) {
        this.router = router;
        this.towerService = towerService;
    }
    QueuesComponent.prototype.ngOnInit = function () {
        this.listerQueues();
    };
    QueuesComponent.prototype.listerQueues = function () {
        var _this = this;
        this.queues = null;
        this.selectedQueue = null;
        this.messages = null;
        this.towerService.listerQueues().subscribe(function (resultat) {
            _this.queues = resultat;
        }, function (error) {
            alert('Erreur durant la recherche');
        });
    };
    QueuesComponent.prototype.queueStyleStandard = function (size) {
        if (size > 0) {
            return { "background": "#ffff66" };
        }
        else {
            return { "background": "#66ff66" };
        }
    };
    QueuesComponent.prototype.queueStyleError = function (size) {
        if (size > 0) {
            return { "background": "#ff3333", "cursor": "pointer" };
        }
        else {
            return { "background": "#66ff66" };
        }
    };
    QueuesComponent.prototype.queueStyleErrorInv = function (size) {
        if (size > 0) {
            return { "background": "#ff9933" };
        }
        else {
            return { "background": "#66ff66" };
        }
    };
    QueuesComponent.prototype.selectQueue = function (queue) {
        var _this = this;
        if (queue.errorAvailable == 0) {
            return;
        }
        this.selectedQueue = queue;
        this.messages = null;
        this.towerService.lireQueue(queue.name).subscribe(function (messages) {
            _this.messages = messages;
        }, function (error) {
            alert('Erreur durant la lecture');
        });
    };
    QueuesComponent.prototype.moveMessage = function (message) {
        var _this = this;
        if (confirm("Réinjecter ce message ?")) {
            this.towerService.injecterMessage(this.selectedQueue.name, message).subscribe(function (res) {
                alert('Déplacement effectué');
                _this.rafraichirMessages(message);
            }, function (err) {
                alert('Erreur durant le déplacement');
            });
        }
    };
    QueuesComponent.prototype.deleteMessage = function (message) {
        var _this = this;
        if (confirm("Supprimer ce message ?")) {
            this.towerService.supprimerMessage(this.selectedQueue.name, message).subscribe(function (res) {
                alert('Suppression effectuée');
                _this.rafraichirMessages(message);
            }, function (err) {
                alert('Erreur durant le déplacement');
            });
        }
    };
    QueuesComponent.prototype.rafraichirMessages = function (message) {
        var msgs = [];
        for (var _i = 0, _a = this.messages; _i < _a.length; _i++) {
            var msg = _a[_i];
            if (msg.id !== message.id) {
                msgs.push(msg);
            }
        }
        this.messages = msgs;
    };
    return QueuesComponent;
}());
export { QueuesComponent };



// WEBPACK FOOTER //
// ./src/app/page/queues/queues.component.ts.pre-build-optimizer.js